module.exports = __webpack_public_path__ + "img/a80e03d.jpg";